/**
 * Check if all order items with purchase orders have been fully received
 * @param orderItems Array of order items to check
 * @returns boolean - true if all items are received, false otherwise
 */
export function checkPurchaseOrdersReceived(orderItems: any[]): boolean {
  // Check if any order item has a purchase order that is not fully received
  for (const orderItem of orderItems) {
    // Skip if no purchase order exists for this item
    if (!orderItem.purchaseOrderID || !orderItem.purchaseOrder) {
      continue
    }

    const purchaseOrder = orderItem.purchaseOrder

    // Find the corresponding purchase order item
    const poItem = purchaseOrder.orderItems?.find(
      (item: any) => item.orderItemID === orderItem.id
    )

    if (poItem) {
      // Check if received quantity matches the requested quantity
      const requestedQty = poItem.quantity || 0
      const receivedQty = poItem.receivedQuantity || 0

      if (receivedQty < requestedQty) {
        return false
      }
    }
  }

  // All purchase orders are fully received
  return true
}

/**
 * Get unreceived purchase order items details
 * @param orderItems Array of order items to check
 * @returns Array of unreceived purchase order details
 */
export function getUnreceivedPurchaseOrderItems(orderItems: any[]): Array<{
  orderItemID: string
  itemName: string
  requestedQty: number
  receivedQty: number
  pendingQty: number
  purchaseOrderID: string
  purchaseOrderExternalID: string
}> {
  const unreceivedItems: Array<{
    orderItemID: string
    itemName: string
    requestedQty: number
    receivedQty: number
    pendingQty: number
    purchaseOrderID: string
    purchaseOrderExternalID: string
  }> = []

  for (const orderItem of orderItems) {
    if (!orderItem.purchaseOrderID || !orderItem.purchaseOrder) {
      continue
    }

    const purchaseOrder = orderItem.purchaseOrder
    const poItem = purchaseOrder.orderItems?.find(
      (item: any) => item.orderItemID === orderItem.id
    )

    if (poItem) {
      const requestedQty = poItem.quantity || 0
      const receivedQty = poItem.receivedQuantity || 0

      if (receivedQty < requestedQty) {
        unreceivedItems.push({
          orderItemID: orderItem.id,
          itemName: orderItem.item?.name || '',
          requestedQty,
          receivedQty,
          pendingQty: requestedQty - receivedQty,
          purchaseOrderID: purchaseOrder.id,
          purchaseOrderExternalID: purchaseOrder.externalID || ''
        })
      }
    }
  }

  return unreceivedItems
}
